module.exports = __webpack_public_path__ + "img/trial_illustration.b326e902.svg";